import { gsap, ScrollTrigger, SplitText } from "../foundation/animation.js";

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(SplitText);
  const titles = gsap.utils.toArray('.c-title');
  titles.forEach(title => {
    const number = title.querySelector('.c-title__number');
    const line = title.querySelector('.c-title__line');
    const text = title.querySelector('.c-title__text');
    const jp = title.querySelector('.c-title__jp');
    const originalJpHTML = jp ? jp.innerHTML : '';
    if (jp) {
      jp.innerHTML = '';
      jp.style.opacity = 0;
    }

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        ScrollTrigger.refresh();
      }
    });

    // 1. Number count up
    if (number) {
      const numValue = parseInt(number.textContent, 10);
      number.textContent = '00';
      const numObj = { val: 0 };
      tl.to(numObj, {
        val: numValue,
        duration: 0.075,
        ease: 'power1.inOut',
        onUpdate: () => {
          number.textContent = String(Math.round(numObj.val)).padStart(2, '0');
        }
      });
    }

    // 2. Line animation
    if (line) {
      tl.to(line, {
        width: () => getComputedStyle(line).getPropertyValue('--target-width').trim(), // or get original width
        duration: 0.075,
        ease: 'power2.inOut'
      });
    }

    // 3. Text animation (ScrambleText)
    if (text) {
      const originalText = text.textContent;
      text.textContent = '';
      tl.to(text, {
        duration: 1,
        scrambleText: {
          text: originalText,
          speed: 0.15,
        },
        ease: "none",
      }, ">");
    }

    // 4. Typing animation for Japanese text
    if (jp) {
        const tokens = originalJpHTML.match(/<[^>]+>|[\s\S]/g) || [];
        const counter = { value: 0 };
        tl.set(jp, { opacity: 1 });
        tl.to(counter, {
            value: tokens.length,
            duration: tokens.length * 0.02,
            ease: `steps(${tokens.length})`,
            onUpdate: () => {
                jp.innerHTML = tokens.slice(0, Math.round(counter.value)).join('');
            },
            onComplete: () => {
                jp.innerHTML = originalJpHTML; // Ensure final HTML is correct
            }
        });
    }

    ScrollTrigger.create({
      trigger: title,
      start: 'top 80%',
      onEnter: () => tl.play(),
      once: true
    });
  });
});
